import { bindEvents } from '../../assets/js/helpers';

// import AnimationController from '../../assets/js/controller/animation';
import ImageController from '../../assets/js/controller/image';


const selector = 'gallery';

export default class Gallery {

	constructor(section) {
		this.el = {
			section,
			images: section.querySelector(`.${selector}__images`),
			captions: section.querySelector(`.${selector}__captions`),
			list: section.querySelector(`.${selector}__images ul`),
			toggleView: section.querySelector(`.${selector}__toggle-view`),
			indexControls: {
				current: section.querySelector('.index-controls__current'),
				total: section.querySelector('.index-controls__total'),
				previous: section.querySelector('.index-controls [data-control-previous]'),
				next: section.querySelector('.index-controls [data-control-next]')
			}
		};

		this.viewport = [0, 0];

		this.height = 0;
		this.width = 0;

		this.position = {
			start: 0,
			last: 0,
			current: 0
		};

		this.items = [];
		this.detail = false;
		this.last = false;

		this.cursor = {
			start: null,
			current: null
		};

		this.events = bindEvents(this);

		this.addEventListeners();
		this.collectImages();
	}

	static get selector() {
		return selector;
	}

	measure() {
		this.viewport = [this.el.images.clientWidth, this.el.images.clientHeight];
		const styles = getComputedStyle(this.el.list);
		this.height = parseInt(styles.getPropertyValue('height'), 10);
	}

	collectImages() {
		const items = this.el.images.querySelectorAll('li');
		this.items = [];
		for (const el of items) {
			const image = el.querySelector('img');
			this.items.push({
				el,
				image,
				figure: el.querySelector('figure'),
				loaded: false,
				aspectRatio: image.naturalWidth / image.naturalHeight,
				position: 0
			});
		}
	}

	positionImages() {
		let totalWidth = 5;
		for (let i = 0, l = this.items.length; i < l; ++i) {
			const width = this.items[i].aspectRatio * this.height;
			this.items[i].position = totalWidth;
			this.items[i].el.style.width = `${width}px`;
			this.items[i].el.style.left = `${this.items[i].position}px`;
			totalWidth += width + 10;
		}
		this.width = totalWidth;
		this.el.list.style.width = `${this.width}px`;
	}

	writeIndex(index) {
		const i = index + 1;
		this.el.indexControls.current.innerText = i < 10 ? `0${i}` : i;
		this.el.indexControls.total.innerText = this.items.length;
	}

	getIndexFromSrc(src) {
		if (src) {
			for (let i = 0, l = this.items.length; i < l; ++i) {
				if (this.items[i].image.dataset.src.replace('-100.jpg', '') === src.replace('-50.jpg', '')) {
					return i;
				}
			}
		}
	}

	determineVisibles() {
		this.visibles = [];
		for (let i = 0, l = this.items.length; i < l; ++i) {
			if (this.items[i].position + this.position.current + this.items[i].aspectRatio * this.height >= 0 && this.items[i].position + this.position.current < this.viewport[0]) {
				this.visibles.push(i);
			}
		}
	}

	loadVisibles() {
		for (const i of this.visibles) {
			this.swapImage(i);
		}
	}

	swapImage(index) {
		if (!this.items[index].loaded) {
			this.items[index].loaded = true;
			ImageController.swap(this.items[index].image);
		}
	}

	positionList(position) {
		if (position > 0) position = 0;
		if (position < -this.width + this.viewport[0]) position = -this.width + this.viewport[0];
		this.position.current = position;
		this.el.list.style.transform = `translate3d(${this.position.current}px,0,0)`;
	}

	show(src) {
		this.measure();
		this.positionImages();
		const index = this.getIndexFromSrc(src);
		if (index || index === 0) {
			this.showDetailview(index);
		} else {
			this.showOverview();
			this.determineVisibles();
			this.loadVisibles();
			this.writeIndex(0);
		}
	}

	showDetailview(index) {
		this.detail = index;
		this.el.section.classList.add('has-detail');
		const width = this.items[this.detail].aspectRatio * this.height;
		this.positionList(-(this.items[this.detail].position - this.viewport[0] / 2 + width / 2));
		const left = this.items[this.detail].position + this.position.current;
		const right = this.viewport[0] - left - width;
		for (let i = 0, l = this.items.length; i < l; ++i) {
			if (i === this.detail) {
				let h = this.viewport[1] - 220,
					w = h * this.items[i].aspectRatio;
				if (w > this.viewport[0]) {
					[w] = this.viewport;
					h = w / this.items[i].aspectRatio;
				}
				const scale = h / this.height;
				const x = (w - width) / 2 - (this.items[i].position + this.position.current);
				const offset = (this.viewport[0] - w) / 2;
				this.items[i].el.classList.add('is-active');
				this.items[i].el.style.transform = `translateX(${x + offset}px) scale3d(${scale},${scale},1)`;
			} else {
				this.items[i].el.classList.remove('is-active');
				if (i < this.detail) {
					this.items[i].el.style.transform = `translateX(${-left}px)`;
				} else if (i > this.detail) {
					this.items[i].el.style.transform = `translateX(${right}px)`;
				}
			}
		}
		const captions = this.el.captions.querySelectorAll('li');
		for (let i = 0, l = captions.length; i < l; ++i) {
			if (captions[i]) captions[i].classList[i === this.detail ? 'add' : 'remove']('is-active');
		}
		this.writeIndex(index);
		this.swapImage(index);
	}

	showOverview() {
		this.last = this.detail;
		this.detail = false;
		this.el.section.classList.remove('has-detail');
		for (let i = 0, l = this.items.length; i < l; ++i) {
			this.items[i].el.classList.remove('is-active');
			this.items[i].el.style.transform = '';
		}
		const captions = this.el.captions.querySelectorAll('li');
		for (let i = 0, l = captions.length; i < l; ++i) {
			if (captions[i]) captions[i].classList.remove('is-active');
		}
	}

	showPrevious() {
		const previous = this.detail - 1;
		if (previous >= 0) this.showDetailview(previous);
	}

	showNext() {
		const next = this.detail + 1;
		if (next < this.items.length) this.showDetailview(next);
	}

	_onWindowLoad() {
		this.measure();
	}

	_onWindowResize() {
		this.measure();
		if (this.detail !== false) this.showDetailview(this.detail);
	}

	_onDocumentMouseMove(e) {
		if (this.cursor.start !== null) {
			this.cursor.last = this.cursor.current;
			this.cursor.current = e.touches ? e.touches[0].pageX : e.clientX;
			this.positionList(this.position.start + (this.cursor.current - this.cursor.start));
		}
	}

	_onDocumentMouseUp(e) {
		if (this.cursor.start !== null) {
			this.el.images.classList.remove('is-dragging');
			if (Math.abs(this.cursor.start - this.cursor.current) < 10) {
				const li = e.target.closest('li');
				for (let i = 0, l = this.items.length; i < l; ++i) {
					if (li === this.items[i].el) this.showDetailview(i);
				}
			} else {
				if (this.detail !== false) {
					this.cursor.current > this.cursor.start ? this.showPrevious() : this.showNext();
				} else {
					this.positionList(this.position.current - (this.cursor.last - this.cursor.current) * 10);
				}
				this.determineVisibles();
				this.loadVisibles();
			}
			this.cursor.start = null;
			this.cursor.current = null;
		}
	}

	_onDocumentKeyDown(e) {
		if (this.detail !== false) {
			if (e.keyCode === 39) this.showNext();
			if (e.keyCode === 37) this.showPrevious();
		}
	}

	_onImagesMouseDown(e) {
		e.preventDefault();
		const x = e.touches ? e.touches[0].pageX : e.clientX;
		this.el.images.classList.add('is-dragging');
		this.position.start = this.position.current;
		this.cursor.start = x;
		this.cursor.current = x;
	}

	_onToggleViewClick() {
		if (this.detail !== false) {
			this.showOverview();
			this.determineVisibles();
			this.loadVisibles();
		} else {
			this.showDetailview(this.last || 0);
		}
	}

	_onIndexControlsPreviousClick(e) {
		e.preventDefault();
		this.showPrevious();
	}

	_onIndexControlsNextClick(e) {
		e.preventDefault();
		this.showNext();
	}

	addEventListeners() {
		window.addEventListener('load', this.events._onWindowLoad);
		window.addEventListener('resize', this.events._onWindowResize);

		document.addEventListener('mousemove', this.events._onDocumentMouseMove);
		document.addEventListener('touchmove', this.events._onDocumentMouseMove);
		document.addEventListener('mouseup', this.events._onDocumentMouseUp);
		document.addEventListener('touchend', this.events._onDocumentMouseUp);
		document.addEventListener('keydown', this.events._onDocumentKeyDown);

		this.el.images.addEventListener('mousedown', this.events._onImagesMouseDown);
		this.el.images.addEventListener('touchstart', this.events._onImagesMouseDown);
		this.el.toggleView.addEventListener('click', this.events._onToggleViewClick);

		this.el.indexControls.previous.addEventListener('click', this.events._onIndexControlsPreviousClick);
		this.el.indexControls.next.addEventListener('click', this.events._onIndexControlsNextClick);
	}

	removeEventListeners() {
		window.removeEventListener('load', this.events._onWindowLoad);
		window.removeEventListener('resize', this.events._onWindowResize);

		document.removeEventListener('mousemove', this.events._onDocumentMouseMove);
		document.removeEventListener('mouseup', this.events._onDocumentMouseUp);
		document.removeEventListener('keydown', this.events._onDocumentKeyDown);

		this.el.images.removeEventListener('mousedown', this.events._onImagesMouseDown);
		this.el.toggleView.removeEventListener('click', this.events._onToggleViewClick);

		this.el.indexControls.previous.removeEventListener('click', this.events._onIndexControlsPreviousClick);
		this.el.indexControls.next.removeEventListener('click', this.events._onIndexControlsNextClick);
	}

}
